// https://codepen.io/gorgonfreeman/pen/dPbzXrr

import { LitElement, html } from 'lit';

class ClickToCopy extends LitElement {
  static properties = {
    useOverlay: { type: Boolean, attribute: 'overlay' },
    buttonText: { type: String, attribute: 'button-text' },
  };

  constructor() {
    super();
    this.useOverlay = false;
    this.buttonText = 'copy';
  }

  createRenderRoot() {
    return this;
  }

  firstUpdated() {
    // Move existing content into the span wrapper
    this.moveContentToSpan();
    
    this.copyButton = this.querySelector('.ctc_button');
    this.copyButton.addEventListener('click', e => this.copyToClipboard(e));
    
    if (this.useOverlay) {
      this.overlay = this.querySelector('.ctc_overlay');
      this.overlay.addEventListener('click', e => this.copyToClipboard(e));
    }
  }

  moveContentToSpan() {
    const contentSpan = this.querySelector('.ctc_content');
    if (!contentSpan) return;
    
    // Get all child nodes except the ones we rendered (button and overlay)
    const childNodes = Array.from(this.childNodes);
    const renderedElements = [this.querySelector('.ctc_button'), this.querySelector('.ctc_overlay')].filter(Boolean);
    
    // Move non-rendered content into the span
    childNodes.forEach(node => {
      if (!renderedElements.includes(node) && node !== contentSpan) {
        contentSpan.appendChild(node);
      }
    });
  }
  
  copyToClipboard() {
    // Get the content from the span wrapper, excluding the copy button and overlay
    const contentSpan = this.querySelector('.ctc_content');
    const htmlContent = contentSpan ? contentSpan.innerHTML : '';
    
    // Create a temporary container element
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlContent;

    // Make the container invisible but ensure it's attached to the DOM
    tempElement.style.position = 'absolute';
    tempElement.style.left = '-9999px';
    document.body.appendChild(tempElement);

    // Select the content in the container
    const range = document.createRange();
    range.selectNodeContents(tempElement);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);

    try {
      // Copy the selected content to the clipboard
      const successful = document.execCommand('copy');
      console.log('copyToClipboard successful', successful ? 'HTML copied to clipboard!' : 'Failed to copy HTML.');
    } catch (err) {
      console.error('Error copying HTML:', err);
    }

    // Cleanup: Remove the temporary element and selection
    selection.removeAllRanges();
    document.body.removeChild(tempElement);
    
    // alert('copied');
  }

  render() {
    return html`
      <span class="ctc_content"></span>
      <button class="ctc_button">${ this.buttonText }</button>
      ${ this.useOverlay ? html`<div class="ctc_overlay"></div>` : '' }
    `;
  }
}

customElements.define('click-to-copy', ClickToCopy);